import * as yup from 'yup';

import { ModalValidationRules } from '$/components/Interactions/types';

export const ProductHuntPromoInteractionValidationRules = (): ModalValidationRules => {
  return {
    integration: yup.object().shape({
      slug: yup.string().nullable().trim().required('You must add a valid Product Hunt link'),
    }),
  };
};
